import {HTH} from "../HTH";
import {gsap} from "gsap";
import {HTHSymbol} from "../symbols/HTHSymbol";
import {HTHSafeSymbol} from "../symbols/HTHSafeSymbol";
import {HTHGameConfig} from "../HTHGameConfig";
import {HTHHelper} from "./HTHHelper";
import {HTHGameMode} from "../server/HTHGameMode";

export class RestoreUtils {

    constructor() {
    }

    public static startUpGame(actualRestore: boolean, isCallFromAS: boolean): void {
        if (isCallFromAS) {
            HTH.reelArea.initForAS();
        }
        if (HTH.model.isCurrentAvalanche) {
            RestoreUtils.normalAvalancheStartup();
        }

        if (!HTH.model.isRestore && !isCallFromAS) {
            RestoreUtils.handleEBforInit();
        } else {
            RestoreUtils.changeEnhancerAnimOnRestore();
        }


        HTH.reelArea.allReels.forEach((reel, i) => {
            reel.reelView.revealSafeSymbols(true);
        })

        HTH.reelArea.nudgeForRestoreOrInit(actualRestore);
        HTH.keypadPlugin.setWin(HTH.model.data.accumulatedRoundWin, true, HTHHelper.isWinBelowStake());

        if (HTH.model.mode.includes("FREESPIN") || HTH.model.nextMode.includes("FREESPIN")) {
            HTH.keypadPlugin.setZeroBetSpinCounter(HTH.model.freespinsLeft);
        }

        if (HTH.model.mode.includes("FREESPIN") || HTH.model.mode === HTHGameMode.EXTRA_SPIN) {
            HTH.gameViewContainer.scatterCollector.showScatterCollector(true);
            const numberofLights: number = HTH.model.data.scatterCountFS % 3;
            HTH.gameViewContainer.scatterCollector.restoreCollectorLight(numberofLights);
        }

        //Calculating big win played amount before restore
        const winRatio: number = HTH.model.initData.spinWin / (+HTH.apiPlugin.betLevel.getLevel());
        for (let i = 0; i < HTH.model.bigWinType.length; i++) {
            if (winRatio >= HTH.model.bigWinType[i].ratio) {
                HTHGameConfig.lastBigWinPlayedAmount = HTH.model.initData.spinWin;
                HTHGameConfig.bigWinLevelPlayed[i] = true;
                if (i === 4) {
                    HTHGameConfig.isBigWinLevel5Played = true;
                }
            }
        }


    }

    public static handleEBforInit(): void {
        HTH.reelArea.allReels[1].reelView.enhancerBlocksInit("inactive_on_nobg");//"blank"
        HTH.reelArea.allReels[2].reelView.enhancerBlocksInit("inactive_on_nobg");
        HTH.reelArea.allReels[3].reelView.enhancerBlocksInit("inactive_on_nobg");
        HTH.reelArea.allReels[4].reelView.enhancerBlocksInit("inactive_on_nobg");
    }

    public static normalAvalancheStartup(): void {
        //used for enhancer reels state
        if (HTH.model.consecutiveAvalanches >= 1) {
            HTH.reelArea.allReels[1].reelView.restoreEnhancerSymbol();
        }
        if (HTH.model.consecutiveAvalanches >= 2) {
            HTH.reelArea.allReels[2].reelView.restoreEnhancerSymbol();
        }
        if (HTH.model.consecutiveAvalanches >= 3) {
            HTH.reelArea.allReels[3].reelView.restoreEnhancerSymbol();
        }
        if (HTH.model.consecutiveAvalanches >= 4) {
            HTH.reelArea.allReels[4].reelView.restoreEnhancerSymbol();
        }

    }

    public static changeEnhancerAnimOnRestore(): void {
        for (let i = 1; i < 5; i++) {
            HTH.reelArea.allReels[i].reelView.changeEnhancerAnimOnRestore();
        }
    }

    public static changeScatterSymbol(changeSpineTo: string): gsap.core.Timeline {
        //next mode:normal, current mode:freespin
        const convertTl: gsap.core.Timeline = gsap.timeline();
        HTH.reelArea.allReels.forEach((item) => {
            item.reelView.getAllSymbols().forEach((sym: HTHSymbol) => {
                if (sym.symName === "SA") {
                    convertTl.add((<HTHSafeSymbol>sym).convertEffects(), 0);
                    convertTl.add(() => {
                        (<HTHSafeSymbol>sym).changeSpine(changeSpineTo, true);
                    }, 0.4);
                    convertTl.add(() => {
                        (<HTHSafeSymbol>sym).symbolAnimChange("normal")
                    }, ">");
                    convertTl.to(this, {duration: 0.05});
                    convertTl.add(() => {
                        (<HTHSafeSymbol>sym).movetoParticularMaskedLayer(HTH.reelArea.allReels[sym.reelId].reelView.reelLayers.safeLayer);
                        // (<HTHSafeSymbol>sym).symbolAnimChange("open_emptyBox")
                        // (<HTHSafeSymbol>sym).symbolAnimChange("open_blank")
                    }, ">");
                }
            });
        });
        convertTl.to(this, {duration: 0.05});
        return convertTl;
    }
}